import { render, staticRenderFns } from "./CreateNewMember.vue?vue&type=template&id=8f420820"
import script from "./CreateNewMember.vue?vue&type=script&lang=js"
export * from "./CreateNewMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports